<template>
  <div class="container">
    <ul>
      <li v-for="courseware in coursewares" :key="courseware._id">
        <p @click="onClick(courseware)">
          {{ courseware.material_authentication.title }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';
import CryptoJS from 'crypto-js';

import BaseURL from '../static/config';

export default {
  name: 'Privacy',
  data() {
    return {
      coursewares: undefined,
    };
  },
  mounted() {
    const userInfoString = localStorage.getItem('bethel_userinfo');
    const dateString = localStorage.getItem('bethel_login_date');
    if (
      !userInfoString ||
      !dateString ||
      userInfoString.length === 0 ||
      dateString.length === 0
    ) {
      this.$router.replace('/login');
    } else {
      const now = new Date().getTime();
      const date = Number(dateString);
      if ((now - date) / (60 * 60 * 24 * 1000) > 3) {
        this.$router.replace('/login');
      }
    }

    const userInfoBytes = CryptoJS.AES.decrypt(
      userInfoString,
      'bethel_mobile_web_key'
    );
    const userInfo = JSON.parse(userInfoBytes.toString(CryptoJS.enc.Utf8));

    axios
      .get(
        `${BaseURL}material_codes?user_id=${userInfo.user_id}&page=1&from_app=true`
      )
      .then((res) => {
        this.coursewares = res.data.items;
      })
      .catch((error) => console.log('---------', error));
  },
  methods: {
    onClick(file) {
      if (file.expired) {
        alert('课件已经过期');
      } else {
        const query = {};

        if (file.material_authentication.original_code) {
          query.code = CryptoJS.AES.encrypt(
            file.material_authentication.original_code,
            'bethel_mobile_web_key'
          ).toString();

          this.$router.push({
            path: '/files',
            query,
          });
        } else {
          query.mId = CryptoJS.AES.encrypt(
            file.material_authentication._id,
            'bethel_mobile_web_key'
          ).toString();

          this.$router.push({
            path: '/files_sources',
            query,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
li {
  padding: 10px 0px;
  text-align: left;
}

.container {
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 100vh;
}
</style>
